import SectionHeading from './SectionHeading';
import { downloadEntries } from '@/mocks/material';

export default function DownloadBar() {
  return (
    <section
      id="download"
      className="relative scroll-mt-24 overflow-hidden bg-background-950"
    >
      <div className="mx-auto max-w-[1240px] px-4 py-14 md:px-6 md:py-20">
        <SectionHeading
          index="06"
          kicker="入口与下载"
          title="整份档期，打包带走"
          desc="历史黑料索引、旧料回顾排期、翻旧账合集与线索校对底稿都可以整包取用。下载即得，方便离线慢慢翻。"
          linkText="查看全部资源"
          light
        />

        <div className="mt-10 grid gap-6 lg:grid-cols-[1.05fr_0.95fr] lg:gap-10">
          {/* 下载列表 */}
          <div className="grid gap-px overflow-hidden rounded-lg border border-background-800 bg-background-800 sm:grid-cols-2">
            {downloadEntries.map((d) => (
              <button
                key={d.name}
                type="button"
                className="group flex items-start gap-4 bg-background-950 p-5 text-left transition-colors hover:bg-background-900 md:p-6"
              >
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-primary-500/15 text-primary-400">
                  <i className={`${d.icon} text-xl`} />
                </span>
                <span className="flex-1">
                  <span className="font-heading block text-sm font-bold text-background-50 md:text-base">{d.name}</span>
                  <span className="mt-1 block text-[11px] leading-5 text-background-300/80">{d.desc}</span>
                  <span className="mt-2 inline-flex items-center gap-1 text-[11px] font-semibold text-secondary-300">
                    <i className="ri-download-2-line" />
                    {d.size}
                  </span>
                </span>
                <i className="ri-arrow-right-s-line text-lg text-background-600 transition-colors group-hover:text-secondary-300" />
              </button>
            ))}
          </div>

          {/* 右侧说明 + CTA */}
          <div className="flex flex-col justify-between gap-8 rounded-lg border border-background-800 bg-background-900 p-6 md:p-8">
            <div>
              <h3 className="font-heading text-lg font-bold text-background-50">本期打包说明</h3>
              <ul className="mt-5 space-y-4 text-sm leading-6 text-background-200/80">
                <li className="flex gap-3">
                  <i className="ri-file-shield-2-line mt-0.5 text-secondary-300" />
                  所有资源均为历史黑料 / 往期爆料存档的整理件，来源页码已随档标注。
                </li>
                <li className="flex gap-3">
                  <i className="ri-refresh-line mt-0.5 text-secondary-300" />
                  索引按季度整档更新，翻旧账合集优先补足完整度低的档位。
                </li>
                <li className="flex gap-3">
                  <i className="ri-lock-2-line mt-0.5 text-secondary-300" />
                  下载资源默认匿名取用，仅用于个人离线回顾，请勿二次外传盈利。
                </li>
              </ul>
            </div>
            <div className="flex flex-col gap-3 sm:flex-row">
              <button
                type="button"
                className="whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
              >
                一键打包全部
              </button>
              <button
                type="button"
                className="whitespace-nowrap rounded-md border border-background-700 px-6 py-3 text-sm font-medium text-background-100 transition-colors hover:border-secondary-400 hover:text-secondary-200"
              >
                申请开放档案
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}